import { useState, useCallback, useEffect } from 'react'
import * as serviceWorkerRegistration from '../serviceWorkerRegistration'

const useServiceWorker = () => {
  const [waitingWorker, setWaitingWorker] = useState(null)
  const [showReload, setShowReload] = useState(false)

  const onSWUpdate = useCallback((registration) => {
    setShowReload(true)
    setWaitingWorker(registration.waiting)
  }, [])

  const reloadPage = useCallback(() => {
    setShowReload(false)

    if (!waitingWorker) {
      window.location.reload()
      return
    }

    // The new worker activates asynchronously after SKIP_WAITING. Reloading
    // right away would just boot the page under the old worker again, which
    // still serves the previous precache. Wait until it takes control.
    let reloaded = false
    const reload = () => {
      if (reloaded) return
      reloaded = true
      window.location.reload()
    }

    navigator.serviceWorker.addEventListener('controllerchange', reload, {
      once: true,
    })
    // Fallback in case controllerchange never fires.
    setTimeout(reload, 3000)

    waitingWorker.postMessage({ type: 'SKIP_WAITING' })
  }, [waitingWorker])

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: onSWUpdate,
    })
  }, [onSWUpdate])

  return { showReload, waitingWorker, reloadPage }
}

export default useServiceWorker
